module.exports = __webpack_public_path__ + "static/media/addisjon.9f305e30.m4a";